import {
  FILTER_REVIEWS_BY_MEDIA_TYPE,
  HIDE_REVIEW_GALLERY_MODAL,
  NAVIGATE_TO_REVIEW,
  RECEIVE_PRODUCT_REVIEWS_WITH_MEDIA,
  REQUEST_PRODUCT_DETAIL,
  REQUEST_PRODUCT_REVIEWS_WITH_MEDIA,
  SELECT_GALLERY_MEDIA,
  SHOW_REVIEW_GALLERY_MODAL,
  SORT_MEDIA_REVIEWS,
  TOGGLE_SHOW_GALLERY
} from 'constants/reduxActions';
import {
  IMAGE,
  IMAGE_OR_VIDEO,
  MOST_HELPFUL,
  VIDEO
} from 'constants/appConstants';

import cleanReviews from 'reducers/reviews/cleanReviews';
const initialState = {
  reviews: [],
  reviewId: null,
  reviewMediaIndex: 0,
  isModalOpen: false,
  isLoading: false,
  isLoaded: false,
  viewMediaType: IMAGE_OR_VIDEO,
  orderBy: MOST_HELPFUL,
  mediaList: []
};

export const makeMediaInfo = reviews => {
  let imageCount = 0;
  let videoCount = 0;
  const reviewCount = reviews.length;
  const mediaList = [];
  for (let j = 0; j < reviewCount; ++j) {
    const { reviewGalleryMedia } = reviews[j];
    if (!reviewGalleryMedia) {
      continue;
    }
    const mediaCount = reviewGalleryMedia.length;
    for (let i = 0; i < mediaCount; ++i) {
      const { mediaType, msaMediaUrl } = reviewGalleryMedia[i];
      mediaList.push({ url: msaMediaUrl, type: mediaType });
      if (mediaType === IMAGE) {
        ++imageCount;
      } else if (mediaType === VIDEO) {
        ++videoCount;
      }
    }
  }
  return { imageCount, videoCount, mediaCount: imageCount + videoCount, mediaList };
};

const reviewGallery = (state = initialState, action) => {
  const { type, reviews, reviewId, reviewMediaIndex, viewMediaType, orderBy } = action;
  switch (type) {
    case SELECT_GALLERY_MEDIA:
      return { ...state, reviewMediaIndex };
    case NAVIGATE_TO_REVIEW:
      return { ...state, reviewId, reviewMediaIndex: 0 };
    case SHOW_REVIEW_GALLERY_MODAL:
      return { ...state, isModalOpen: true, reviewId, reviewMediaIndex };
    case TOGGLE_SHOW_GALLERY:
      return { ...state, reviewId: null };
    case FILTER_REVIEWS_BY_MEDIA_TYPE:
      return { ...state, viewMediaType };
    case REQUEST_PRODUCT_DETAIL:
      return { ...initialState };
    case REQUEST_PRODUCT_REVIEWS_WITH_MEDIA:
      return { ...state, isLoading: true, isLoaded: false };
    case RECEIVE_PRODUCT_REVIEWS_WITH_MEDIA:
      const cleanedReviews = cleanReviews(reviews);
      const { imageCount, videoCount, mediaCount, mediaList } = makeMediaInfo(cleanedReviews);
      return { ...state, reviews: cleanedReviews, isLoading: false, isLoaded: true, imageCount, videoCount, mediaCount, mediaList };
    case SORT_MEDIA_REVIEWS:
      return { ...state, orderBy };
    case HIDE_REVIEW_GALLERY_MODAL:
      return { ...state, isModalOpen: false, reviewId: null, reviewMediaIndex: 0, viewMediaType: IMAGE_OR_VIDEO };
    default:
      return state;
  }
};

export default reviewGallery;
